
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9m5D8", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1b25e149e99979c$export$2e2bcd8739ae039);

var $erVR3 = parcelRequire("erVR3");

var $lO7zi = parcelRequire("lO7zi");

var $hCdov = parcelRequire("hCdov");
class $c1b25e149e99979c$export$2e2bcd8739ae039 {
    cCoord;
    center = new (0, $lO7zi.default)("O");
    tags = [];
    constructor(cCoord, tags){
        this.cCoord = cCoord;
        this.tags = tags.map((tag)=>new (0, $lO7zi.default)(tag));
        this.updateCenter();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.setAllVisible(false));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.setAllVisible(true));
    }
    updateCenter = ()=>this.center.updateCoord({
            x: this.cCoord.x + 21,
            y: this.cCoord.y + 21
        });
    setAllVisible = (visible)=>[
            this.center,
            ...this.tags
        ].forEach((pTag)=>pTag.visible = visible);
    updateCoord(radians, radius) {
        const coords = (0, $hCdov.default)(this.cCoord, radians, radius + 30);
        coords.forEach((coord, cI)=>this.tags[cI].updateCoord(coord));
    }
}

});

parcelRegister("f8pkD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5728371334eb545$export$2e2bcd8739ae039);

var $g4gW0 = parcelRequire("g4gW0");

var $a92Ax = parcelRequire("a92Ax");

var $eP48i = parcelRequire("eP48i");

var $erVR3 = parcelRequire("erVR3");
class $a5728371334eb545$export$2e2bcd8739ae039 {
    rootEventBus = (0, $erVR3.rootEventBus);
    EnumRootEventBus = (0, $erVR3.EnumRootEventBus);
    Angles = [];
    constructor(anglePropsArr, followCircleAnim = true){
        this.Angles = anglePropsArr.map((angleProps, aI)=>new (0, $g4gW0.default)(`a${aI + 1}`, angleProps.angleColors, angleProps.smallDistanceOffset, angleProps.addCon, angleProps.addSmallDis));
        if (followCircleAnim) {
            this.rootEventBus.on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.setAllVisible(false));
            this.rootEventBus.on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.setAllVisible(true));
        }
    }
    setAllVisible = (v)=>this.Angles.forEach((angle)=>angle.setVisible(v));
    getAngles = ()=>this.Angles;
    drawAngle(angle, p, degree, clockwise) {
        const { startRadian: startRadian, endRadian: endRadian } = (0, $a92Ax.default)(p.curr, p.prev, p.next);
        const smllDistance = Math.floor(Math.min((0, $eP48i.default)(p.curr, p.prev), (0, $eP48i.default)(p.curr, p.next)));
        angle.smallDistance = smllDistance;
        angle.draw(p.curr, startRadian, endRadian, degree, !clockwise);
        angle.x = p.curr.x;
        angle.y = p.curr.y;
        angle.rotation = 0;
    }
}

});
parcelRegister("g4gW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0d65a8310461d1d$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");

var $i30uN = parcelRequire("i30uN");

var $3f3J1 = parcelRequire("3f3J1");
class $b0d65a8310461d1d$export$2e2bcd8739ae039 extends $iuB9z.Container {
    Layers = (0, $9ec1t.default).getInstance();
    AngleValue;
    arc;
    arcStroke;
    tag;
    startRadian;
    endRadian;
    degree;
    fillColor;
    smallDistance = 100;
    smallDistanceOffset = 0;
    addSmallDis = true;
    constructor(tag, angleColor, smallDistanceOffset = 0, addCon = false, addSmallDis = true){
        super();
        this.tag = tag;
        this.fillColor = angleColor.color;
        this.smallDistanceOffset = smallDistanceOffset;
        this.addSmallDis = addSmallDis;
        this.AngleValue = new (0, $i30uN.default)({
            x: -100,
            y: -100
        }, angleColor.textColor);
        this.addArc();
        !addCon && this.addToLayer();
    }
    addToLayer = ()=>this.Layers.Bottom.addChild(this);
    addArc() {
        this.arc = new $iuB9z.Graphics();
        this.addChild(this.arc);
        this.arcStroke = new $iuB9z.Graphics();
        this.addChild(this.arcStroke);
    }
    setVisible(status) {
        this.visible = status;
        this.AngleValue.visible = status;
    }
    draw(cCoord, startRadian, endRadian, degree, cClockwise) {
        const sD = this.smallDistance;
        const radian = sD <= 76 + this.smallDistanceOffset && this.addSmallDis ? Math.max((sD - this.smallDistanceOffset) / 2, 15) : 38;
        this.degree = degree;
        this.startRadian = startRadian;
        this.endRadian = endRadian;
        if (degree == 90) {
            this.arcStroke.clear();
            (0, $3f3J1.drawSquare)(this.arc, radian, startRadian, endRadian, this.fillColor, cClockwise);
        } else {
            (0, $3f3J1.drawArc)(this.arcStroke, radian, startRadian, endRadian, 3, 0x000000, cClockwise, true);
            (0, $3f3J1.drawArc)(this.arc, radian / 2, startRadian, endRadian, radian, this.fillColor, cClockwise, false);
        }
        const initialAngle = cClockwise ? endRadian : startRadian;
        this.AngleValue.setAngleValue(cCoord, initialAngle, degree, radian);
    }
}

});
parcelRegister("i30uN", function(module, exports) {

$parcel$export(module.exports, "default", () => $6935df93860f2c37$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");

var $eymUv = parcelRequire("eymUv");
class $6935df93860f2c37$export$2e2bcd8739ae039 extends $iuB9z.Text {
    Layers = (0, $9ec1t.default).getInstance();
    constructor(coord, color){
        super();
        this.text = "60\xb0";
        this.style.fill = color;
        this.style.fontSize = 34;
        this.style.fontWeight = "800";
        this.anchor.set(.5);
        this.setAngleValue(coord, 0, 0, 38);
        this.addToLayer();
    }
    addToLayer = ()=>this.Layers.Top.addChild(this);
    setValue = (value)=>this.text = `${value}\xb0`;
    setAngleValue(cCoord, initialAngle, degree, radian) {
        const angle = initialAngle + (0, $eymUv.default)(degree / 2);
        const coord = {
            x: Math.cos(angle) * radian * 1.7 + cCoord.x,
            y: Math.sin(angle) * radian * 1.7 + cCoord.y
        };
        this.setValue(degree);
        this.style.fontSize = radian;
        this.x = coord.x;
        this.y = coord.y;
    }
}

});
parcelRegister("eymUv", function(module, exports) {

$parcel$export(module.exports, "default", () => $0afd35e271dc067b$export$2e2bcd8739ae039);
function $0afd35e271dc067b$export$2e2bcd8739ae039(degree) {
    return degree * (Math.PI / 180);
}

});


parcelRegister("3f3J1", function(module, exports) {

$parcel$export(module.exports, "drawArc", () => $827e00f616855d7e$export$bf8a3f9983094125);
$parcel$export(module.exports, "drawSquare", () => $827e00f616855d7e$export$9340b6a85ea854b9);
function $827e00f616855d7e$export$bf8a3f9983094125(arc, r, sRadian, eRadian, w, color, cClockwise, isStroke) {
    arc.clear();
    if (!isStroke) arc.arc(0, 0, r, sRadian, eRadian, cClockwise).stroke({
        width: w,
        color: color
    });
    else arc.moveTo(Math.cos(sRadian) * r, Math.sin(sRadian) * r).lineTo(0, 0).arc(0, 0, r, sRadian, eRadian, cClockwise).moveTo(0, 0).lineTo(Math.cos(eRadian) * r, Math.sin(eRadian) * r).stroke({
        width: w,
        color: color
    });
    arc.rotation = 0;
}
function $827e00f616855d7e$export$9340b6a85ea854b9(square, dim, startRadian, endRadian, color, cClockwise) {
    square.clear();
    square.rect(0, 0, dim, dim).fill(color).stroke({
        color: 0x000000,
        width: 3
    });
    square.rotation = !cClockwise ? startRadian : endRadian;
}

});


parcelRegister("a92Ax", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f2e4f2e6d187ae4$export$2e2bcd8739ae039);

var $2h5MD = parcelRequire("2h5MD");
function $1f2e4f2e6d187ae4$export$2e2bcd8739ae039(cCoord, coordStart, coordEnd) {
    const startRadian = (0, $2h5MD.default)(cCoord, coordStart);
    const endRadian = (0, $2h5MD.default)(cCoord, coordEnd);
    return {
        startRadian: startRadian,
        endRadian: endRadian
    };
}

});


parcelRegister("5Y8dU", function(module, exports) {

$parcel$export(module.exports, "default", () => $c70362288d20b67e$export$2e2bcd8739ae039);
function $c70362288d20b67e$export$2e2bcd8739ae039(A, B, C) {
    // definate vectors
    const BA = [
        A.x - B.x,
        A.y - B.y
    ];
    const BC = [
        C.x - B.x,
        C.y - B.y
    ];
    // dot product
    const dotProduct = BA[0] * BC[0] + BA[1] * BC[1];
    // dimension of vectors
    const magnitudeBA = Math.hypot(BA[0], BA[1]);
    const magnitudeBC = Math.hypot(BC[0], BC[1]);
    // calc angles as radian
    const angleRad = Math.acos(dotProduct / (magnitudeBA * magnitudeBC));
    const angleDeg = Math.round(Number((angleRad * (180 / Math.PI)).toFixed(2)));
    return angleDeg;
}

});

parcelRegister("eitLW", function(module, exports) {

$parcel$export(module.exports, "default", () => $295d8ae516c805d1$export$2e2bcd8739ae039);

var $erVR3 = parcelRequire("erVR3");

var $16Wgx = parcelRequire("16Wgx");

var $16HUD = parcelRequire("16HUD");

var $gcphA = parcelRequire("gcphA");
class $295d8ae516c805d1$export$2e2bcd8739ae039 {
    CheckboxRenderer;
    isChecked = false;
    checkBoxLabel;
    handleFunc;
    constructor(coord, label, color, useCustomLayer = false, handleFunc = (label, v)=>{}){
        this.CheckboxRenderer = new (0, $gcphA.default)(color, label, useCustomLayer);
        Object.assign(this.CheckboxRenderer, coord);
        this.handleFunc = handleFunc;
        this.addInteractivity();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.setVisible(false));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.setVisible(true));
    }
    addToCon = (con)=>con.addChild(this.CheckboxRenderer);
    setScale = (v)=>this.CheckboxRenderer.con.scale.set(v);
    setVisible = (v)=>this.CheckboxRenderer.visible = v;
    addInteractivity() {
        const handleUpFunc = ()=>this.handleCheckbox();
        (0, $16Wgx.default)(this.CheckboxRenderer, {
            handleUpFunc: handleUpFunc
        }, (0, $16HUD.CustomCursorType).pointer, undefined, true);
    }
    handleCheckbox() {
        this.isChecked = !this.isChecked;
        this.handleFunc(this.checkBoxLabel, this.isChecked);
        this.CheckboxRenderer.drawCheckbox(this.isChecked);
    }
    getIsChecked() {
        return {
            label: this.checkBoxLabel,
            isChecked: this.isChecked
        };
    }
    setChecked(v) {
        this.isChecked = v;
        this.CheckboxRenderer.drawCheckbox(this.isChecked);
    }
}

});
parcelRegister("gcphA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6f182ab57cf75ac$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");
class $c6f182ab57cf75ac$export$2e2bcd8739ae039 extends $iuB9z.Container {
    color;
    checkboxLabel;
    Layers;
    con;
    checkedSquare;
    defaultColor;
    constructor(color, checkboxLabel, useCustomLayer = false){
        super(), this.color = color, this.checkboxLabel = checkboxLabel, this.Layers = (0, $9ec1t.default).getInstance(), this.con = this.addChild(new $iuB9z.Container()), this.checkedSquare = this.con.addChild(new $iuB9z.Graphics()), this.defaultColor = 0xFFFFFF, this.addToLayer = ()=>this.Layers.UI.addChild(this);
        this.drawCheckbox(false);
        this.addLabel();
        !useCustomLayer && this.addToLayer();
    }
    addToLayer;
    drawCheckbox(isColored) {
        const fillColor = isColored ? this.color : this.defaultColor;
        this.checkedSquare.clear().roundRect(0, -20, 40, 40, 10).fill(fillColor).stroke({
            width: 2,
            color: 0x000000
        });
    }
    addLabel() {
        const text = new $iuB9z.Text({
            text: this.checkboxLabel
        });
        text.style.fontSize = 36;
        text.style.fill = this.color;
        text.anchor.set(0, .5);
        text.x = 50;
        text.y = 0;
        this.con.addChild(text);
    }
}

});


parcelRegister("jISXQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $66faaaf67ef5cb50$export$2e2bcd8739ae039);
function $66faaaf67ef5cb50$export$2e2bcd8739ae039(dim, CENTER_OF_CIRCLE) {
    if (dim.WIDTH > dim.HEIGHT) return CENTER_OF_CIRCLE;
    return {
        x: dim.WIDTH / 2,
        y: dim.HEIGHT / 2
    };
}

});

parcelRegister("jtirH", function(module, exports) {

$parcel$export(module.exports, "default", () => $34c5a2df4ae2bc79$export$2e2bcd8739ae039);
function $34c5a2df4ae2bc79$export$2e2bcd8739ae039(cCoord, cCircumPoint, aSide1, aSide2) {
    let angle = Math.atan2(cCircumPoint.y - cCoord.y, cCircumPoint.x - cCoord.x);
    if (angle < 0) angle += 2 * Math.PI;
    let start = aSide1;
    let end = aSide2;
    if (start < 0) start += 2 * Math.PI;
    if (end < 0) end += 2 * Math.PI;
    if (start <= end) return angle >= start && angle <= end;
    else return angle >= start || angle <= end;
}

});

parcelRegister("gix9M", function(module, exports) {

$parcel$export(module.exports, "default", () => $4713a546dfab5e00$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $75RpY = parcelRequire("75RpY");

var $9ec1t = parcelRequire("9ec1t");

var $krubk = parcelRequire("krubk");

var $erVR3 = parcelRequire("erVR3");
class $4713a546dfab5e00$export$2e2bcd8739ae039 extends $iuB9z.Container {
    Game = (0, $75RpY.default).getInstance();
    Layers = (0, $9ec1t.default).getInstance();
    Switcher;
    Header;
    coords;
    handleFunc;
    constructor({ header: header, coords: coords, handleFunc: handleFunc }){
        super();
        this.coords = coords;
        this.handleFunc = handleFunc;
        this.addHeader(header);
        this.addCoord();
        this.addSwitcher();
        this.addToLayer();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.setVisible(false));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.setVisible(true));
    }
    setVisible = (v)=>this.visible = v;
    addToLayer = ()=>this.Layers.UI.addChild(this);
    addCoord() {
        const dim = this.Game.getDim();
        let coord = this.coords.horizontal;
        if (dim.WIDTH < dim.HEIGHT) coord = {
            x: dim.WIDTH / 2 + this.coords.vertical.x,
            y: dim.HEIGHT / 2 + this.coords.vertical.y
        };
        Object.assign(this, coord);
    }
    addHeader(header) {
        this.Header = new $iuB9z.Text({
            text: header
        });
        this.Header.anchor.set(.5);
        this.Header.x = 0;
        this.Header.y = -32;
        this.addChild(this.Header);
    }
    addSwitcher() {
        const dim = this.Game.getDim();
        this.Switcher = new (0, $krubk.default)(0x55E39F, this.handleFunc, true);
        this.Switcher.scale.set(dim.WIDTH > dim.HEIGHT ? 1.3 : 1.9);
        this.Switcher.x = 0;
        this.Switcher.y = 0;
        this.addChild(this.Switcher);
    }
    getActivationStatus = ()=>this.Switcher.getActive();
    setActivation(v) {
        const isActive = this.Switcher.getActive();
        if (v && isActive) this.Switcher.handleSwitcher(!isActive);
    }
}

});
parcelRegister("krubk", function(module, exports) {

$parcel$export(module.exports, "default", () => $621ca3294779f8aa$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");

var $8xLbP = parcelRequire("8xLbP");

var $erVR3 = parcelRequire("erVR3");

var $16Wgx = parcelRequire("16Wgx");

var $16HUD = parcelRequire("16HUD");
const $621ca3294779f8aa$var$BUTTON_X = 10;
class $621ca3294779f8aa$export$2e2bcd8739ae039 extends $iuB9z.Container {
    Layers = (0, $9ec1t.default).getInstance();
    isActive = false;
    greenBg;
    grayBg;
    button;
    handleSwitch;
    constructor(color, handleSwitch, isAddCon = false){
        super();
        this.handleSwitch = handleSwitch;
        this.greenBg = this.addBg(color);
        this.grayBg = this.addBg(0xDEDEDE);
        this.addButton(0xFFFFFF);
        this.addInteractivity();
        !isAddCon && this.addToLayer();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).closeSwitcher, ()=>this.handleSwitcherOff());
    }
    addToLayer = ()=>this.Layers.UI.addChild(this);
    getActive = ()=>this.isActive;
    addBg(color) {
        const bgBound = {
            width: 40,
            height: 20
        };
        const bg = new $iuB9z.Graphics().clear().roundRect(-bgBound.width / 2, -bgBound.height / 2, bgBound.width, bgBound.height).fill(color);
        this.addChild(bg);
        return bg;
    }
    handleSwitcher(isActive) {
        this.isActive = isActive;
        this.handleSwitch(this.isActive);
        new (0, $8xLbP.default)(this);
    }
    handleSwitcherOff() {
        if (!this.isActive) return;
        this.handleSwitcher(false);
    }
    addInteractivity() {
        const handleDownFunc = ()=>this.handleSwitcher(!this.isActive);
        (0, $16Wgx.default)(this, {
            handleDownFunc: handleDownFunc
        }, (0, $16HUD.CustomCursorType).pointer, undefined, true);
    }
    setActive(v) {
        this.grayBg.alpha = this.isActive ? 1 - v : v;
        this.greenBg.alpha = this.isActive ? v : 1 - v;
        this.button.x = this.isActive ? 2 * $621ca3294779f8aa$var$BUTTON_X * v : 2 * $621ca3294779f8aa$var$BUTTON_X * (1 - v);
    }
    addButton(color) {
        this.button = new $iuB9z.Graphics().circle(-$621ca3294779f8aa$var$BUTTON_X, 0, 8).fill(color);
        this.addChild(this.button);
    }
}

});
parcelRegister("8xLbP", function(module, exports) {

$parcel$export(module.exports, "default", () => $074e271eb87a9bab$export$2e2bcd8739ae039);

var $6m47o = parcelRequire("6m47o");

var $1PAc2 = parcelRequire("1PAc2");
class $074e271eb87a9bab$export$2e2bcd8739ae039 extends (0, $1PAc2.default) {
    constructor(Switcher){
        super();
        const alpha = 0;
        new (0, $6m47o.default).Tween({
            alpha: alpha
        }).to({
            alpha: 1
        }, 500).easing((0, $6m47o.default).Easing.Linear.None).onUpdate(({ alpha: alpha })=>{
            Switcher.setActive(alpha);
        }).start();
    }
}

});



parcelRegister("beJMG", function(module, exports) {

$parcel$export(module.exports, "getTextureBatchBindGroup", () => $24797d7b1c25d5bc$export$84c26df82650dc9b);

var $awcfo = parcelRequire("awcfo");

var $bLlTJ = parcelRequire("bLlTJ");
"use strict";
const $24797d7b1c25d5bc$var$cachedGroups = {};
function $24797d7b1c25d5bc$export$84c26df82650dc9b(textures, size, maxTextures) {
    let uid = 2166136261;
    for(let i = 0; i < size; i++){
        uid ^= textures[i].uid;
        uid = Math.imul(uid, 16777619);
        uid >>>= 0;
    }
    return $24797d7b1c25d5bc$var$cachedGroups[uid] || $24797d7b1c25d5bc$var$generateTextureBatchBindGroup(textures, size, uid, maxTextures);
}
function $24797d7b1c25d5bc$var$generateTextureBatchBindGroup(textures, size, key, maxTextures) {
    const bindGroupResources = {};
    let bindIndex = 0;
    for(let i = 0; i < maxTextures; i++){
        const texture = i < size ? textures[i] : (0, $bLlTJ.Texture).EMPTY.source;
        bindGroupResources[bindIndex++] = texture.source;
        bindGroupResources[bindIndex++] = texture.style;
    }
    const bindGroup = new (0, $awcfo.BindGroup)(bindGroupResources);
    $24797d7b1c25d5bc$var$cachedGroups[key] = bindGroup;
    return bindGroup;
}

});

parcelRegister("6RGCN", function(module, exports) {

$parcel$export(module.exports, "CanvasPool", () => $cb3b5b020b2ab749$export$e56d0a06781accc9);

var $iCGeI = parcelRequire("iCGeI");

var $NbSCN = parcelRequire("NbSCN");

var $2GH55 = parcelRequire("2GH55");
"use strict";
class $cb3b5b020b2ab749$export$62d9f0b8aada09d7 {
    constructor(canvasOptions){
        this._canvasPool = /* @__PURE__ */ Object.create(null);
        this.canvasOptions = canvasOptions || {};
        this.enableFullScreen = false;
    }
    /**
   * Creates texture with params that were specified in pool constructor.
   * @param pixelWidth - Width of texture in pixels.
   * @param pixelHeight - Height of texture in pixels.
   */ _createCanvasAndContext(pixelWidth, pixelHeight) {
        const canvas = (0, $iCGeI.DOMAdapter).get().createCanvas();
        canvas.width = pixelWidth;
        canvas.height = pixelHeight;
        const context = canvas.getContext("2d");
        return {
            canvas: canvas,
            context: context
        };
    }
    /**
   * Gets a Power-of-Two render texture or fullScreen texture
   * @param minWidth - The minimum width of the render texture.
   * @param minHeight - The minimum height of the render texture.
   * @param resolution - The resolution of the render texture.
   * @returns The new render texture.
   */ getOptimalCanvasAndContext(minWidth, minHeight, resolution = 1) {
        minWidth = Math.ceil(minWidth * resolution - 1e-6);
        minHeight = Math.ceil(minHeight * resolution - 1e-6);
        minWidth = (0, $NbSCN.nextPow2)(minWidth);
        minHeight = (0, $NbSCN.nextPow2)(minHeight);
        const key = (minWidth << 17) + (minHeight << 1);
        if (!this._canvasPool[key]) this._canvasPool[key] = [];
        let canvasAndContext = this._canvasPool[key].pop();
        if (!canvasAndContext) canvasAndContext = this._createCanvasAndContext(minWidth, minHeight);
        return canvasAndContext;
    }
    /**
   * Place a render texture back into the pool.
   * @param canvasAndContext
   */ returnCanvasAndContext(canvasAndContext) {
        const canvas = canvasAndContext.canvas;
        const { width: width, height: height } = canvas;
        const key = (width << 17) + (height << 1);
        canvasAndContext.context.resetTransform();
        canvasAndContext.context.clearRect(0, 0, width, height);
        this._canvasPool[key].push(canvasAndContext);
    }
    clear() {
        this._canvasPool = {};
    }
}
const $cb3b5b020b2ab749$export$e56d0a06781accc9 = new $cb3b5b020b2ab749$export$62d9f0b8aada09d7();
(0, $2GH55.GlobalResourceRegistry).register($cb3b5b020b2ab749$export$e56d0a06781accc9);

});

parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});


var $75RpY = parcelRequire("75RpY");

var $75RpY = parcelRequire("75RpY");

var $erVR3 = parcelRequire("erVR3");

var $iuB9z = parcelRequire("iuB9z");
var $c70bdf1d90b60bda$export$cb883390c27ec6dd = /*#__PURE__*/ function(EnumEventBus) {
    EnumEventBus["setPointChecklist"] = "SET_POINT_CHECK_LIST";
    EnumEventBus["moveCircumPoints"] = "MOVE_CIRCUMFERENCE_POINTS";
    EnumEventBus["KiteMode"] = "KITE_MODE";
    EnumEventBus["Triangle1Mode"] = "TRIANGLE_1_MODE";
    EnumEventBus["Triangle2Mode"] = "TRIANGLE_2_MODE";
    EnumEventBus["genRanIntersec"] = "GENERATE_RANDOMLY_INTERSECTION";
    return EnumEventBus;
}({});
const $c70bdf1d90b60bda$export$f6644f0f2c90144b = new (0, $iuB9z.EventEmitter)();



var $fGH3X = parcelRequire("fGH3X");

var $iiVV4 = parcelRequire("iiVV4");

var $5ehzb = parcelRequire("5ehzb");

var $aPdzS = parcelRequire("aPdzS");
const $d50f3166974d9b82$export$7a003cdef7722780 = [
    0xFC99C4,
    0xF94F6F
];
const $d50f3166974d9b82$export$c7609d9da8d80867 = {
    x: 600,
    y: 310
};
const $d50f3166974d9b82$export$ca8f2c484d507a5d = 200;
const $d50f3166974d9b82$export$95c476c8e1b0007 = [
    Math.PI / 2,
    -Math.PI / 9
];
const $d50f3166974d9b82$export$bdea539c223eec51 = [
    0x000000,
    0x000000,
    0x000000
];
const $d50f3166974d9b82$export$186dbbe504e85fe1 = [
    {
        x: 410,
        y: 800
    }
];
const $d50f3166974d9b82$export$75f2cc8245aafe09 = [
    {
        x: 60,
        y: 420
    }
];
const $d50f3166974d9b82$export$840ec2322406bfdd = {
    x: 1180,
    y: 200
};
const $d50f3166974d9b82$export$1312ecbb29a79419 = {
    x: 215,
    y: 800
};
const $d50f3166974d9b82$export$bd764feb9b5e3f0b = Math.PI / 3 * 2;
const $d50f3166974d9b82$export$d3524dc9d2a26f82 = [
    0xFF0000,
    0x0000FF,
    0x00FF00,
    0xFFFF00
];
const $d50f3166974d9b82$export$2e51dc0dfab2d766 = "circle-theorem-7";




var $2h5MD = parcelRequire("2h5MD");

var $darcK = parcelRequire("darcK");

var $iD90R = parcelRequire("iD90R");

function $e9aa377adf5ac186$export$9ab8d65b20cc4c12(cCoord, pointA, pointB) {
    // y = m * x + b
    const slopeA = Math.tan((0, $darcK.normalizeRadian)((0, $2h5MD.default)(pointA, cCoord) + Math.PI / 2));
    const slopeB = Math.tan((0, $darcK.normalizeRadian)((0, $2h5MD.default)(pointB, cCoord) + Math.PI / 2));
    // b = y - m * x
    const bA = pointA.y - slopeA * pointA.x;
    const bB = pointB.y - slopeB * pointB.x;
    // x = (b2 - b1) / (m1 - m2)
    const x = Number(((bB - bA) / (slopeA - slopeB)).toFixed(2));
    const y = Number((slopeB * x + bB).toFixed(2));
    return {
        x: x,
        y: y
    };
}
function $e9aa377adf5ac186$export$4777bb8a9f19b87(PointManager) {
    const OffsetUnit = (0, $d50f3166974d9b82$export$bd764feb9b5e3f0b) / 5;
    const randomOffsetB = OffsetUnit + Math.random() * ((0, $d50f3166974d9b82$export$bd764feb9b5e3f0b) - OffsetUnit);
    const randomA = (0, $darcK.normalizeRadian)(Math.random() * (Math.PI * 2));
    const randomB = (0, $darcK.normalizeRadian)(randomA + randomOffsetB);
    const newRadians = [
        randomA,
        randomB
    ];
    const RefRadians = PointManager.getRefRadians();
    const points = PointManager.getRedPoints();
    newRadians.map((v)=>v * (Math.PI / 3)).sort().reverse();
    (0, $iD90R.moveAllPointAnim)(RefRadians, newRadians, (radian, index)=>{
        PointManager.setRadian([
            {
                pTag: points[index].tag,
                radian: radian
            }
        ]);
    });
}
function $e9aa377adf5ac186$export$16e8707de8ba0dbb(cCoord, pointA, pointB, clockwise) {
    const length = 80;
    const slopeA = (0, $darcK.normalizeRadian)((0, $2h5MD.default)(pointA, cCoord) + (clockwise ? 1 : -1) * Math.PI / 2);
    const slopeB = (0, $darcK.normalizeRadian)((0, $2h5MD.default)(pointB, cCoord) + (clockwise ? -1 : 1) * Math.PI / 2);
    const tangentA = {
        x: Math.cos(slopeA) * length + pointA.x,
        y: Math.sin(slopeA) * length + pointA.y
    };
    const tangentB = {
        x: Math.cos(slopeB) * length + pointB.x,
        y: Math.sin(slopeB) * length + pointB.y
    };
    return [
        tangentA,
        tangentB
    ];
}
function $e9aa377adf5ac186$export$d52692c6983e7d02(a, b) {
    let delta = a - b;
    while(delta > Math.PI)delta -= 2 * Math.PI;
    while(delta < -Math.PI)delta += 2 * Math.PI;
    return delta;
}
function $e9aa377adf5ac186$export$f6017383cfd26c44(pointInfoArr, RedPointsArr, pointRadians) {
    let _pointInfoArr = [
        ...pointInfoArr
    ];
    if (pointInfoArr.length === 1) {
        const index = RedPointsArr.findIndex((point)=>point.tag === pointInfoArr[0].pTag);
        const otherIndex = index === 0 ? 1 : 0;
        const firstRadian = (0, $darcK.normalizeRadian)(pointInfoArr[0].radian);
        const secondOriginalRadian = (0, $darcK.normalizeRadian)(pointRadians[otherIndex]);
        const delta = $e9aa377adf5ac186$export$d52692c6983e7d02(firstRadian, secondOriginalRadian);
        let secondRadian = secondOriginalRadian;
        if (Math.abs(delta) > (0, $d50f3166974d9b82$export$bd764feb9b5e3f0b)) {
            if (delta > 0) secondRadian = firstRadian - (0, $d50f3166974d9b82$export$bd764feb9b5e3f0b);
            else secondRadian = firstRadian + (0, $d50f3166974d9b82$export$bd764feb9b5e3f0b);
            _pointInfoArr.push({
                pTag: RedPointsArr[otherIndex].tag,
                radian: secondRadian
            });
        }
    }
    return _pointInfoArr;
}


class $657e9b4ce0411da0$export$2e2bcd8739ae039 extends (0, $5ehzb.default) {
    intersecPoint = new (0, $aPdzS.default)({
        x: -100,
        y: -100
    });
    pointCheckList = [];
    constructor(cCoord){
        super(cCoord, (0, $d50f3166974d9b82$export$ca8f2c484d507a5d), (0, $d50f3166974d9b82$export$95c476c8e1b0007));
        this.setCoord();
        this.draw();
        const intersecCoord = this.getIntersecCoord();
        this.intersecPoint.draw(intersecCoord);
        (0, $c70bdf1d90b60bda$export$f6644f0f2c90144b).on((0, $c70bdf1d90b60bda$export$cb883390c27ec6dd).setPointChecklist, (l)=>this.pointCheckList = l);
        (0, $c70bdf1d90b60bda$export$f6644f0f2c90144b).on((0, $c70bdf1d90b60bda$export$cb883390c27ec6dd).moveCircumPoints, (v)=>this.moveCircumPoints(v));
        (0, $c70bdf1d90b60bda$export$f6644f0f2c90144b).on((0, $c70bdf1d90b60bda$export$cb883390c27ec6dd).genRanIntersec, ()=>this.generateNewIntersection());
    }
    setIntersecPointVisible = (v)=>this.intersecPoint.visible = v;
    generateNewIntersection = ()=>(0, $e9aa377adf5ac186$export$4777bb8a9f19b87)(this);
    getIntersecCoord = ()=>(0, $e9aa377adf5ac186$export$9ab8d65b20cc4c12)(this.cCoord, this.RedPointsArr[0], this.RedPointsArr[1]);
    getTangentCoords = (clockwise)=>(0, $e9aa377adf5ac186$export$16e8707de8ba0dbb)(this.cCoord, this.RedPointsArr[0], this.RedPointsArr[1], clockwise);
    setRadian(_pointInfoArr, isSlider) {
        const pointInfoArr = (0, $e9aa377adf5ac186$export$f6017383cfd26c44)(_pointInfoArr, this.RedPointsArr, this.pointRadians);
        this._setRadian(pointInfoArr, isSlider);
        if (this.intersecPoint.visible) {
            const intersecCoord = this.getIntersecCoord();
            this.intersecPoint.draw(intersecCoord);
        }
    }
    moveCircumPoints(v) {
        const points = this.getRedPoints();
        const radians = this.getRefRadians();
        const generateOffsetRadian = (v)=>Math.PI / 300 * v;
        const pointInfoArr = this.pointCheckList.map((e, eI)=>this.pointRefRadians[eI] + (e ? generateOffsetRadian(v) : 0)).map((r, rI)=>({
                pTag: points[rI].tag,
                radian: r
            })).filter((pointInfo, pII)=>pointInfo.radian != radians[pII]);
        this.setRadian(pointInfoArr, true);
    }
}



var $9m5D8 = parcelRequire("9m5D8");
class $d2fd893fc05a5b05$export$2e2bcd8739ae039 extends (0, $9m5D8.default) {
    constructor(cCoord){
        super(cCoord, [
            "A",
            "B",
            "C",
            "D"
        ]);
    }
}



var $d0yDD = parcelRequire("d0yDD");

var $erVR3 = parcelRequire("erVR3");

class $eed49e1c8e403cd6$export$2e2bcd8739ae039 {
    cCoord;
    Triangle1Mode;
    Triangle2Mode;
    lines;
    constructor(cCoord){
        this.cCoord = cCoord;
        this.Triangle1Mode = false;
        this.Triangle2Mode = false;
        this.lines = [
            new (0, $d0yDD.default)(),
            new (0, $d0yDD.default)(),
            new (0, $d0yDD.default)({
                color: 0xb06efe,
                isEqualSymbol: true
            }),
            new (0, $d0yDD.default)({
                color: 0xb06efe,
                isEqualSymbol: true
            }),
            new (0, $d0yDD.default)({
                color: 0xb06efe
            }),
            new (0, $d0yDD.default)({
                color: 0xb06efe
            }),
            new (0, $d0yDD.default)({
                color: 0x09d9c9,
                isDashed: true
            }),
            new (0, $d0yDD.default)({
                color: 0x09d9c9,
                isDashed: true
            })
        ];
        this.setAllVisible = (status)=>[
                ...this.lines
            ].forEach((l)=>l.visible = status);
        this.lines[2].setVisibleOfEqualSymbol(true);
        this.lines[3].setVisibleOfEqualSymbol(true);
        (0, $c70bdf1d90b60bda$export$f6644f0f2c90144b).on((0, $c70bdf1d90b60bda$export$cb883390c27ec6dd).Triangle1Mode, (v)=>this.Triangle1Mode = v);
        (0, $c70bdf1d90b60bda$export$f6644f0f2c90144b).on((0, $c70bdf1d90b60bda$export$cb883390c27ec6dd).Triangle2Mode, (v)=>this.Triangle2Mode = v);
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.clearAll());
    }
    setAllVisible;
    clearAll() {
        this.lines[2].setVisibleOfEqualSymbol(false);
        this.lines[3].setVisibleOfEqualSymbol(false);
        this.lines.forEach((l)=>l.clear());
    }
    draw(points, tPoints, interSecPoint) {
        if (this.Triangle1Mode) {
            this.lines[6].draw(points[0], points[1]);
            this.lines[0].clear();
            this.lines[1].clear();
            this.lines[7].clear();
        } else if (this.Triangle2Mode) {
            this.lines[7].draw(this.cCoord, interSecPoint);
            this.lines[0].draw(this.cCoord, points[0]);
            this.lines[1].draw(this.cCoord, points[1]);
            this.lines[6].clear();
        } else {
            this.lines[0].draw(this.cCoord, points[0]);
            this.lines[1].draw(this.cCoord, points[1]);
            this.lines[6].clear();
            this.lines[7].clear();
        }
        this.lines[2].draw(points[0], interSecPoint);
        this.lines[3].draw(points[1], interSecPoint);
        this.lines[4].draw(tPoints[0], interSecPoint);
        this.lines[5].draw(tPoints[1], interSecPoint);
    }
}




var $f8pkD = parcelRequire("f8pkD");

var $5Y8dU = parcelRequire("5Y8dU");

const $df54c01cd93ed517$var$pAC = (0, $d50f3166974d9b82$export$7a003cdef7722780);
const $df54c01cd93ed517$export$8043c9fcad664653 = Array(8).fill(null).map((_, i)=>({
        angleColors: {
            color: $df54c01cd93ed517$var$pAC[0],
            textColor: $df54c01cd93ed517$var$pAC[1]
        },
        smallDistanceOffset: 20
    }));
function $df54c01cd93ed517$export$5f61282e9abe72d5(points, cCoord, interSecPoint, clockwise) {
    return [
        {
            curr: points[0],
            prev: interSecPoint,
            next: cCoord,
            clockwise: clockwise
        },
        {
            curr: points[1],
            prev: cCoord,
            next: interSecPoint,
            clockwise: clockwise
        },
        {
            curr: points[1],
            prev: points[0],
            next: interSecPoint,
            clockwise: clockwise
        },
        {
            curr: points[0],
            prev: points[1],
            next: interSecPoint,
            clockwise: !clockwise
        },
        {
            curr: cCoord,
            prev: interSecPoint,
            next: points[0],
            clockwise: !clockwise
        },
        {
            curr: cCoord,
            prev: interSecPoint,
            next: points[1],
            clockwise: clockwise
        },
        {
            curr: interSecPoint,
            prev: cCoord,
            next: points[0],
            clockwise: clockwise
        },
        {
            curr: interSecPoint,
            prev: cCoord,
            next: points[1],
            clockwise: !clockwise
        }
    ];
}


class $16ae771f9e1afcbd$export$2e2bcd8739ae039 extends (0, $f8pkD.default) {
    cCoord;
    Triangle1Mode = false;
    Triangle2Mode = false;
    constructor(cCoord){
        super((0, $df54c01cd93ed517$export$8043c9fcad664653), false);
        this.cCoord = cCoord;
        this.checkVisibles();
        (0, $c70bdf1d90b60bda$export$f6644f0f2c90144b).on((0, $c70bdf1d90b60bda$export$cb883390c27ec6dd).KiteMode, (v)=>v ? this.setAllVisible(false) : this.checkVisibles());
        (0, $c70bdf1d90b60bda$export$f6644f0f2c90144b).on((0, $c70bdf1d90b60bda$export$cb883390c27ec6dd).Triangle1Mode, (v)=>this.handleTriangleMode1(v));
        (0, $c70bdf1d90b60bda$export$f6644f0f2c90144b).on((0, $c70bdf1d90b60bda$export$cb883390c27ec6dd).Triangle2Mode, (v)=>this.handleTriangleMode2(v));
        this.rootEventBus.on(this.EnumRootEventBus.startedCircleAnim, ()=>this.setVisible(false));
        this.rootEventBus.on(this.EnumRootEventBus.completedCircleAnim, ()=>this.setVisible(true));
    }
    setVisible(v) {
        if (v) {
            this.Angles[0].setVisible(true);
            this.Angles[1].setVisible(true);
            return;
        }
        this.setAllVisible(v);
    }
    handleTriangleMode1(v) {
        this.Triangle1Mode = v;
        v && (this.Triangle2Mode = false);
        this.checkVisibles();
    }
    handleTriangleMode2(v) {
        this.Triangle2Mode = v;
        v && (this.Triangle1Mode = false);
        this.checkVisibles();
    }
    checkVisibles() {
        this.setAllVisible(false);
        let indexs = [
            0,
            1
        ];
        if (this.Triangle1Mode) indexs = [
            2,
            3
        ];
        else if (this.Triangle2Mode) indexs = [
            0,
            1,
            4,
            5,
            6,
            7
        ];
        indexs.forEach((i)=>this.Angles[i].setVisible(true));
    }
    draw(points, interSecPoint, clockwise = true) {
        const Points = (0, $df54c01cd93ed517$export$5f61282e9abe72d5)(points, this.cCoord, interSecPoint, clockwise);
        Points.forEach((P, pI)=>{
            const degree = pI < 2 ? 90 : (0, $5Y8dU.default)(P.curr, P.prev, P.next);
            this.drawAngle(this.Angles[pI], P, degree, P.clockwise);
        });
    }
}



var $eitLW = parcelRequire("eitLW");

var $b2sIL = parcelRequire("b2sIL");


const $8f543521805d8c71$var$SliderGen = [
    {
        head: "move tangent points",
        subHead: "(select which one to use)",
        colors: {
            bgColor: 0xB5A1FF,
            barColor: 0x000000,
            buttonColor: 0xB5A1FF
        },
        onUpdate: (v)=>(0, $c70bdf1d90b60bda$export$f6644f0f2c90144b).emit((0, $c70bdf1d90b60bda$export$cb883390c27ec6dd).moveCircumPoints, v - 100)
    }
];
const $8f543521805d8c71$var$pointName = [
    "Point A",
    "Point B"
];
class $8f543521805d8c71$export$2e2bcd8739ae039 extends (0, $b2sIL.default) {
    pointCheckboxes = [];
    pointChecklist = Array(2).fill(false);
    constructor(){
        super($8f543521805d8c71$var$SliderGen, (0, $d50f3166974d9b82$export$186dbbe504e85fe1), (0, $d50f3166974d9b82$export$75f2cc8245aafe09));
        this.addCheckBoxes();
    }
    handleCheckbox(index, v) {
        this.pointChecklist[index] = v;
        (0, $c70bdf1d90b60bda$export$f6644f0f2c90144b).emit((0, $c70bdf1d90b60bda$export$cb883390c27ec6dd).setPointChecklist, this.pointChecklist);
    }
    addCheckBoxes() {
        const coords = $8f543521805d8c71$var$getPointCheckboxCoords(this.dim);
        this.pointCheckboxes = Array(2).fill((0, $d50f3166974d9b82$export$7a003cdef7722780)[0]).map((e, eI)=>new (0, $eitLW.default)(coords[eI], $8f543521805d8c71$var$pointName[eI], e, false, (label, v)=>this.handleCheckbox(eI, v)));
        this.dim.WIDTH < this.dim.HEIGHT && this.pointCheckboxes.forEach((cbox)=>cbox.setScale(.8));
    }
}
function $8f543521805d8c71$var$getPointCheckboxCoords(dim) {
    const coordHorizontal = [
        {
            x: 745,
            y: 775
        },
        {
            x: 745,
            y: 825
        }
    ];
    const getCoordHorizontal = (eI)=>coordHorizontal[eI];
    const getCoordVertical = (eI)=>({
            x: dim.WIDTH / 2 + 35 + (eI > 1 ? 150 : 0),
            y: dim.HEIGHT / 2 + 520 + (eI % 2 == 1 ? 40 : 0)
        });
    const coords = Array(2).fill(null).map((e, eI)=>dim.WIDTH > dim.HEIGHT ? getCoordHorizontal(eI) : getCoordVertical(eI == 1 ? eI + 1 : eI));
    return coords;
}



var $erVR3 = parcelRequire("erVR3");


var $iD90R = parcelRequire("iD90R");


var $darcK = parcelRequire("darcK");
async function $8a38459f71d13308$export$2721aded6352b5ea(context, onComp) {
    const { circle: circle, LineManager: LineManager, PointManager: PointManager, AngleManager: AngleManager, cCoord: cCoord } = context;
    const centerPoint = PointManager.getPoints()[0];
    const intersecPoint = PointManager.intersecPoint;
    const centerPointCoord = PointManager.getPointsCoord()[0];
    const pointsCoord = PointManager.getRedPointsCoord();
    const tangentCoords = PointManager.getTangentCoords(false);
    const RedPoints = PointManager.getRedPoints();
    const interSecCoord = PointManager.getIntersecCoord();
    const initialRadian = PointManager.getInitialRadians();
    const angles = AngleManager.getAngles();
    PointManager.setIntersecPointVisible(false);
    AngleManager.draw(pointsCoord, interSecCoord, false);
    circle.setRadians([
        (0, $d50f3166974d9b82$export$95c476c8e1b0007)[0],
        (0, $d50f3166974d9b82$export$95c476c8e1b0007)[0]
    ]);
    (0, $iD90R.drawPointsAnim)([
        centerPoint
    ]);
    await (0, $iD90R.drawCircleAnim)(circle, (0, $d50f3166974d9b82$export$95c476c8e1b0007)[0] + Math.PI * 2, 0, true, cCoord);
    await (0, $iD90R.drawLineAnim)(LineManager.lines[0], centerPointCoord, pointsCoord[0]);
    await (0, $iD90R.drawLineAnim)(LineManager.lines[1], centerPointCoord, pointsCoord[1]);
    intersecPoint.draw(interSecCoord);
    (0, $iD90R.drawPointsAnim)([
        intersecPoint
    ]);
    await (0, $iD90R.drawLineAnim)(LineManager.lines[2], interSecCoord, tangentCoords[0]);
    await (0, $iD90R.drawLineAnim)(LineManager.lines[3], interSecCoord, tangentCoords[1]);
    LineManager.lines[2].draw(interSecCoord, pointsCoord[0]);
    LineManager.lines[3].draw(interSecCoord, pointsCoord[1]);
    LineManager.lines[4].draw(interSecCoord, tangentCoords[0]);
    LineManager.lines[5].draw(interSecCoord, tangentCoords[1]);
    await (0, $iD90R.addCustomDelay)(100);
    LineManager.lines[2].setVisibleOfEqualSymbol(true);
    LineManager.lines[3].setVisibleOfEqualSymbol(true);
    await (0, $iD90R.addCustomDelay)(500);
    (0, $iD90R.drawAngleAnim)(angles[0], "x");
    await (0, $iD90R.drawAngleAnim)(angles[1], "x");
    await (0, $iD90R.rotateCircleAnim)((v)=>{
        const arr = Array(2).fill(v).map((v, vI)=>({
                pTag: RedPoints[vI].tag,
                radian: (0, $darcK.normalizeRadian)(initialRadian[vI] + v)
            }));
        PointManager.setRadian(arr);
    });
    await (0, $iD90R.drawPointsAnim)(RedPoints);
    onComp();
}



var $e8wW1 = parcelRequire("e8wW1");

class $2abd030ccd893ee4$export$2e2bcd8739ae039 {
    PointManager;
    AngleManager;
    LineManager;
    circle;
    cCoord;
    isKiteMode;
    isT1Mode;
    isT2Mode;
    constructor(PointManager, AngleManager, LineManager, circle, cCoord){
        this.PointManager = PointManager;
        this.AngleManager = AngleManager;
        this.LineManager = LineManager;
        this.circle = circle;
        this.cCoord = cCoord;
        this.isKiteMode = false;
        this.isT1Mode = false;
        this.isT2Mode = false;
        this.getDelayForStartAnim = ()=>this.isKiteMode || this.isT1Mode || this.isT2Mode ? 600 : 0;
        this.addCircAnimBut = ()=>new (0, $e8wW1.default)((0, $d50f3166974d9b82$export$840ec2322406bfdd), ()=>this.runAnimations(), ()=>this.getDelayForStartAnim());
        const interSecCoord = PointManager.getIntersecCoord();
        this.AngleManager.draw(PointManager.getRedPoints(), interSecCoord, true);
        this.addCircAnimBut();
        (0, $c70bdf1d90b60bda$export$f6644f0f2c90144b).on((0, $c70bdf1d90b60bda$export$cb883390c27ec6dd).KiteMode, (v)=>this.isKiteMode = v);
        (0, $c70bdf1d90b60bda$export$f6644f0f2c90144b).on((0, $c70bdf1d90b60bda$export$cb883390c27ec6dd).Triangle1Mode, (v)=>this.isT1Mode = v);
        (0, $c70bdf1d90b60bda$export$f6644f0f2c90144b).on((0, $c70bdf1d90b60bda$export$cb883390c27ec6dd).Triangle2Mode, (v)=>this.isT2Mode = v);
    }
    getDelayForStartAnim;
    addCircAnimBut;
    runAnimations() {
        (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).startedCircleAnim);
        const context = {
            PointManager: this.PointManager,
            AngleManager: this.AngleManager,
            LineManager: this.LineManager,
            circle: this.circle,
            cCoord: this.cCoord
        };
        (0, $8a38459f71d13308$export$2721aded6352b5ea)(context, ()=>{
            (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).getCircleCoord, {
                x: this.circle.x,
                y: this.circle.y
            });
            (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).completedCircleAnim);
        });
    }
}



var $3DpJv = parcelRequire("3DpJv");

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");

var $d0yDD = parcelRequire("d0yDD");


var $ijoTh = parcelRequire("ijoTh");

class $a5acad52c620602b$export$2e2bcd8739ae039 extends $iuB9z.Container {
    Layers = (0, $9ec1t.default).getInstance();
    Lines = [];
    Graphics = [];
    cCoord;
    constructor(cCoord){
        super();
        this.cCoord = cCoord;
        this.addGraphics();
        this.addLines();
        (0, $c70bdf1d90b60bda$export$f6644f0f2c90144b).on((0, $c70bdf1d90b60bda$export$cb883390c27ec6dd).KiteMode, (v)=>{
            if (!v) {
                this.Graphics.forEach((g)=>g.clear());
                this.Lines.forEach((l)=>l.clear());
            }
        });
    }
    addGraphics() {
        this.Graphics = [
            new $iuB9z.Graphics(),
            new $iuB9z.Graphics(),
            new $iuB9z.Graphics(),
            new $iuB9z.Graphics()
        ];
        this.Graphics.forEach((g, i)=>this.Layers.Bottom.addChild(g));
    }
    addLines() {
        Array(2).fill("").forEach(()=>{
            const line = new (0, $d0yDD.default)();
            this.Layers.Middle.addChild(line);
            this.Lines.push(line);
        });
    }
    fillTriangles(points, intersecCoord) {
        const midPoint = (0, $ijoTh.default)(points[0], points[1]);
        const Points = [
            points[0],
            this.cCoord,
            points[1],
            intersecCoord
        ];
        this.Graphics.forEach((g, i)=>{
            const firstPoint = midPoint;
            const secondPoint = Points[i];
            const thirdPoint = Points[(i + 1) % Points.length];
            g.clear();
            g.moveTo(firstPoint.x, firstPoint.y);
            g.lineTo(secondPoint.x, secondPoint.y);
            g.lineTo(thirdPoint.x, thirdPoint.y);
            g.fill((0, $d50f3166974d9b82$export$d3524dc9d2a26f82)[i]);
        });
    }
    draw(points = [], intersecCoord) {
        this.Lines[0].draw(points[0], points[1]);
        this.Lines[1].draw(this.cCoord, intersecCoord);
        this.fillTriangles(points, intersecCoord);
    }
}



var $75RpY = parcelRequire("75RpY");

var $erVR3 = parcelRequire("erVR3");


var $llFKB = parcelRequire("llFKB");

const $d6b58afb0479cc70$var$ButtonStyle = {
    width: 280,
    height: 120,
    wordWrapWidth: 160,
    defaultColor: 0xCECECE,
    hoverColor: 0xDEDEDE,
    pressedColor: 0xC5C5C5,
    borderColor: 0x111111,
    titleColor: 0x111111,
    titleFontSize: 28,
    borderRadius: 22
};
class $d6b58afb0479cc70$export$2e2bcd8739ae039 extends (0, $llFKB.default) {
    Game = (0, $75RpY.default).getInstance();
    constructor(){
        super("Generate Random Intersection", $d6b58afb0479cc70$var$ButtonStyle, ()=>this.genRandomIntersec());
        this.addCoord();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.setVisible(false));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.setVisible(true));
    }
    genRandomIntersec = ()=>(0, $c70bdf1d90b60bda$export$f6644f0f2c90144b).emit((0, $c70bdf1d90b60bda$export$cb883390c27ec6dd).genRanIntersec);
    setVisible = (v)=>this.visible = v;
    addCoord() {
        const dim = this.Game.getDim();
        if (dim.WIDTH > dim.HEIGHT) {
            this.x = (0, $d50f3166974d9b82$export$1312ecbb29a79419).x;
            this.y = (0, $d50f3166974d9b82$export$1312ecbb29a79419).y;
            return;
        }
        this.x = dim.WIDTH / 2 - 170;
        this.y = dim.HEIGHT / 2 + 420;
    }
}



var $jISXQ = parcelRequire("jISXQ");


var $jtirH = parcelRequire("jtirH");

var $gix9M = parcelRequire("gix9M");

const $bb6b7e0d5dc3e579$var$header = "Kite Mode:";
const $bb6b7e0d5dc3e579$var$handleFunc = (isActive)=>(0, $c70bdf1d90b60bda$export$f6644f0f2c90144b).emit((0, $c70bdf1d90b60bda$export$cb883390c27ec6dd).KiteMode, isActive);
const $bb6b7e0d5dc3e579$var$coords = {
    vertical: {
        x: -160,
        y: 550
    },
    horizontal: {
        x: 100,
        y: 320
    }
};
class $bb6b7e0d5dc3e579$export$2e2bcd8739ae039 extends (0, $gix9M.default) {
    constructor(){
        super({
            header: $bb6b7e0d5dc3e579$var$header,
            coords: $bb6b7e0d5dc3e579$var$coords,
            handleFunc: $bb6b7e0d5dc3e579$var$handleFunc
        });
        (0, $c70bdf1d90b60bda$export$f6644f0f2c90144b).on((0, $c70bdf1d90b60bda$export$cb883390c27ec6dd).Triangle1Mode, (v)=>this.setActivation(v));
        (0, $c70bdf1d90b60bda$export$f6644f0f2c90144b).on((0, $c70bdf1d90b60bda$export$cb883390c27ec6dd).Triangle2Mode, (v)=>this.setActivation(v));
    }
    setActivation(v) {
        if (v) {
            const isActive = this.Switcher.getActive();
            if (isActive) this.Switcher.handleSwitcherOff();
        }
    }
}



var $gix9M = parcelRequire("gix9M");

const $e8b76670a6a92056$var$header = "Triangle Mode 1:";
const $e8b76670a6a92056$var$handleFunc = (isActive)=>(0, $c70bdf1d90b60bda$export$f6644f0f2c90144b).emit((0, $c70bdf1d90b60bda$export$cb883390c27ec6dd).Triangle1Mode, isActive);
const $e8b76670a6a92056$var$coords = {
    vertical: {
        x: -160,
        y: 625
    },
    horizontal: {
        x: 100,
        y: 400
    }
};
class $e8b76670a6a92056$export$2e2bcd8739ae039 extends (0, $gix9M.default) {
    constructor(){
        super({
            header: $e8b76670a6a92056$var$header,
            coords: $e8b76670a6a92056$var$coords,
            handleFunc: $e8b76670a6a92056$var$handleFunc
        });
        (0, $c70bdf1d90b60bda$export$f6644f0f2c90144b).on((0, $c70bdf1d90b60bda$export$cb883390c27ec6dd).KiteMode, (v)=>this.setActivation(v));
        (0, $c70bdf1d90b60bda$export$f6644f0f2c90144b).on((0, $c70bdf1d90b60bda$export$cb883390c27ec6dd).Triangle2Mode, (v)=>this.setActivation(v));
    }
    setActivation(v) {
        if (v) {
            const isActive = this.Switcher.getActive();
            if (isActive) this.Switcher.handleSwitcherOff();
        }
    }
}



var $gix9M = parcelRequire("gix9M");

const $239e4bc762454a25$var$header = "Triangle Mode 2:";
const $239e4bc762454a25$var$handleFunc = (isActive)=>(0, $c70bdf1d90b60bda$export$f6644f0f2c90144b).emit((0, $c70bdf1d90b60bda$export$cb883390c27ec6dd).Triangle2Mode, isActive);
const $239e4bc762454a25$var$coords = {
    vertical: {
        x: 180,
        y: 625
    },
    horizontal: {
        x: 100,
        y: 480
    }
};
class $239e4bc762454a25$export$2e2bcd8739ae039 extends (0, $gix9M.default) {
    constructor(){
        super({
            header: $239e4bc762454a25$var$header,
            coords: $239e4bc762454a25$var$coords,
            handleFunc: $239e4bc762454a25$var$handleFunc
        });
        (0, $c70bdf1d90b60bda$export$f6644f0f2c90144b).on((0, $c70bdf1d90b60bda$export$cb883390c27ec6dd).KiteMode, (v)=>this.setActivation(v));
        (0, $c70bdf1d90b60bda$export$f6644f0f2c90144b).on((0, $c70bdf1d90b60bda$export$cb883390c27ec6dd).Triangle1Mode, (v)=>this.setActivation(v));
    }
    setActivation(v) {
        if (v) {
            const isActive = this.Switcher.getActive();
            if (isActive) this.Switcher.handleSwitcherOff();
        }
    }
}


class $65b649e41cdc93ff$export$2e2bcd8739ae039 {
    static instance;
    Game = (0, $75RpY.default).getInstance();
    circleRadius = (0, $d50f3166974d9b82$export$ca8f2c484d507a5d);
    cCoord = (0, $jISXQ.default)(this.Game.getDim(), (0, $d50f3166974d9b82$export$c7609d9da8d80867));
    SliderManager = new (0, $8f543521805d8c71$export$2e2bcd8739ae039)();
    PointManager = new (0, $657e9b4ce0411da0$export$2e2bcd8739ae039)(this.cCoord);
    PointTagManager = new (0, $d2fd893fc05a5b05$export$2e2bcd8739ae039)(this.cCoord);
    LineManager = new (0, $eed49e1c8e403cd6$export$2e2bcd8739ae039)(this.cCoord);
    InfoSlider = new (0, $fGH3X.default)((0, $d50f3166974d9b82$export$840ec2322406bfdd));
    AngleManager = new (0, $16ae771f9e1afcbd$export$2e2bcd8739ae039)(this.cCoord);
    circle = new (0, $iiVV4.default)(this.cCoord, (0, $d50f3166974d9b82$export$95c476c8e1b0007), (0, $d50f3166974d9b82$export$bdea539c223eec51));
    CircleAnimationManager;
    kite = new (0, $a5acad52c620602b$export$2e2bcd8739ae039)(this.cCoord);
    KiteModeSwitcher = new (0, $bb6b7e0d5dc3e579$export$2e2bcd8739ae039)();
    Triangle1Switcher = new (0, $e8b76670a6a92056$export$2e2bcd8739ae039)();
    Triangle2Switcher = new (0, $239e4bc762454a25$export$2e2bcd8739ae039)();
    KiteMode = false;
    constructor(){
        if (!$65b649e41cdc93ff$export$2e2bcd8739ae039.instance) $65b649e41cdc93ff$export$2e2bcd8739ae039.instance = this;
        new (0, $3DpJv.default)();
        new (0, $d6b58afb0479cc70$export$2e2bcd8739ae039)();
        this.CircleAnimationManager = new (0, $2abd030ccd893ee4$export$2e2bcd8739ae039)(this.PointManager, this.AngleManager, this.LineManager, this.circle, this.cCoord);
        this.drawElements();
        (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).getCircleCoord, this.cCoord);
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).drawElements, ()=>this.drawElements());
        (0, $c70bdf1d90b60bda$export$f6644f0f2c90144b).on((0, $c70bdf1d90b60bda$export$cb883390c27ec6dd).KiteMode, (v)=>{
            this.KiteMode = v;
            this.drawElements();
        });
        (0, $c70bdf1d90b60bda$export$f6644f0f2c90144b).on((0, $c70bdf1d90b60bda$export$cb883390c27ec6dd).Triangle1Mode, ()=>this.drawElements());
        (0, $c70bdf1d90b60bda$export$f6644f0f2c90144b).on((0, $c70bdf1d90b60bda$export$cb883390c27ec6dd).Triangle2Mode, ()=>this.drawElements());
    }
    static getInstance = ()=>$65b649e41cdc93ff$export$2e2bcd8739ae039.instance;
    drawElements() {
        const radians = this.PointManager.getRadians();
        const redPointsCoord = this.PointManager.getRedPointsCoord();
        const interSecCoord = this.PointManager.getIntersecCoord();
        const isbtw = (0, $jtirH.default)(this.cCoord, interSecCoord, radians[0], radians[1]);
        const tangentCoords = this.PointManager.getTangentCoords(isbtw);
        this.circle.draw({
            radians: radians,
            radius: this.circleRadius
        });
        this.PointTagManager.updateCoord(radians, this.circleRadius);
        this.LineManager.draw(redPointsCoord, tangentCoords, interSecCoord);
        this.AngleManager.draw(redPointsCoord, interSecCoord, isbtw);
        this.KiteMode && this.kite.draw(redPointsCoord, interSecCoord);
    }
}



const $3c0e12552c84a84e$var$canvas = document.querySelector("#canvas");
if ($3c0e12552c84a84e$var$canvas) window.context = new (0, $75RpY.default)($3c0e12552c84a84e$var$canvas, (0, $d50f3166974d9b82$export$2e51dc0dfab2d766), ()=>new (0, $65b649e41cdc93ff$export$2e2bcd8739ae039)());
else console.error("Canvas is not found");


//# sourceMappingURL=index.fa63a3e5.js.map
